import { Play } from "lucide-react";

export default function HeroSide({ side }) {
  if (side === "left") {
    return (
      <div className="md:col-span-2 md:self-start md:pt-6 fade-up-delay-1" data-testid="hero-side-left">
        <p className="text-[11px] tracking-[0.2em] uppercase text-neutral-500 mb-2">
          Freelance Developer
        </p>
        <p className="display text-[15px] md:text-[16px] font-bold leading-snug max-w-[220px]">
          WORDPRESS, SHOPIFY &amp;
          <br className="hidden md:block" /> WOOCOMMERCE FOR
          <br className="hidden md:block" /> MODERN BRANDS
        </p>
      </div>
    );
  }
  return (
    <div className="md:col-span-2 flex md:flex-col items-center md:items-end md:self-start justify-between md:justify-start gap-4 fade-up-delay-3">
      <a
        href="#work"
        className="relative w-[104px] h-[104px] md:w-[120px] md:h-[120px] block"
        data-testid="hero-explore-badge"
      >
        <svg viewBox="0 0 100 100" className="absolute inset-0 spin-slow">
          <defs>
            <path id="heroBadge" d="M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" />
          </defs>
          <text className="fill-black text-[9px] tracking-[0.3em] font-semibold">
            <textPath href="#heroBadge">EXPLORE MY WORK · PORTFOLIO ·</textPath>
          </text>
        </svg>
        <span className="absolute inset-0 m-auto w-11 h-11 rounded-full border-2 border-black flex items-center justify-center hover:bg-black hover:text-white transition-colors">
          <Play size={14} fill="currentColor" className="ml-0.5" />
        </span>
      </a>
      <p className="display text-lg md:hidden">#2025</p>
    </div>
  );
}
